var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-items-center"},[_c('span',{staticClass:"rbi rbi-webcam"}),_vm._v(" "+_vm._s(_vm.$t('actionPages.orderTypes.chatVideo'))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }